import { IStore } from 'old-store/types';

export const getShippingStore = ({ shipping }: IStore) => shipping;
